"use client";
import { app } from "@/lib/firebase-util";
import { getAnalytics, isSupported } from "firebase/analytics";

export const getGoogleAnalytics = async () => {
    return isSupported().then((y) => (y ? getAnalytics(app) : null));
}


const FirebaseAnalytics = () => {
    const analytics = getGoogleAnalytics();
    return <></>;
};

export default FirebaseAnalytics;
